import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import { isEmpty } from 'lodash';
import { useRouter } from 'next/router';
import { getLayoutProps } from '@/utils/layout/layout';
import { getCMSHomepageGrid } from '@/api/cms';
import User from '@/store/user';
import LoyaltyTransactionsHistory from '@/components/LoyaltyTransactionsHistory/LoyaltyTransactionsHistory';
import PageLayout from '@/components/PageLayout';
import { getOrFetchConfiguration } from '@/utils/getConfiguration';
import EmptyTransactions from '../../../../../public/assets/wave-grocery/transactions_empty.png';
export default function UserLoyalty({ responsiveLogo, image }) {
  const [user, setUser] = useState();
  const [config, setConfig] = useState();
  const [showLoyaltyCardButton, setShowLoyaltyCardButton] = useState(false);

  const router = useRouter();
  useEffect(() => {
    const user$ = User.subscribe(_user => {
      if (isEmpty(_user)) {
        router.replace('/login');
        return;
      }
      setUser(_user);
    });
    return () => user$.unsubscribe();
  }, []);

  useEffect(() => {
    async function getConfiguration() {
      const configuration = await getOrFetchConfiguration();
      setConfig(configuration);
      setShowLoyaltyCardButton(configuration?.loyalty?.digitalWallet?.enabled);
      if (!configuration?.loyalty?.enabled) {
        router.replace('/');
        return;
      }
      return;
    }

    getConfiguration();
  }, []);

  if (!user?._id) return null;

  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>
      <LoyaltyTransactionsHistory user={user} image={image} showLoyaltyCardButton={showLoyaltyCardButton} />
    </>
  );
}

UserLoyalty.getLayout = function getLayout(page) {
  return (
    <PageLayout isUserLayout userSelectedMenu={'loyalty'}>
      {page}
    </PageLayout>
  );
};

export async function getStaticProps({ locale }) {
  const [layoutProps, { data: loyalty }] = await Promise.all([
    getLayoutProps({ headerProps: { selectedIndex: 0 } }, locale),
    getCMSHomepageGrid('loyalty_card', locale),
  ]).catch(error => {
    console.error(`>>> getStaticProps initialGifts error: ${error}`);
  });

  const image = layoutProps?.emptyStates?.cards_empty_state?.url
    ? layoutProps?.emptyStates?.cards_empty_state?.url
    : EmptyTransactions.src;
  const messages = {
    common: (await import(`../../../../../prebuild-data/i18n/${locale}/common.json`)).default,
    user_loyalty: (await import(`../../../../../prebuild-data/i18n/${locale}/user_loyalty.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      messages,
      image,
    },
  };
}
